// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  background: var(--main-background);
  color: white;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
}

.header-section {
  padding: 20px;
}

.header-btn {
  justify-content: flex-end;
}
.header-btn ion-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.header-wrap {
  padding: 10px 0 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.name {
  margin: 0;
  font-size: 22px;
  color: white;
  font-family: AppFontMedium, sans-serif;
}

.email {
  margin: 4px 0 0;
  font-size: 14px;
  font-family: AppFont, sans-serif;
  color: var(--ion-color-subtitle);
}

.section-title {
  margin: 24px 0 4px;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent-color);
  font-family: AppFontMedium, sans-serif;
}

.menu-row {
  padding: 14px 0;
  font-size: 16px;
  font-family: AppFontMedium, sans-serif;
  color: white;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.menu-row:hover {
  color: var(--accent-color);
}

.footer-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.lang-block {
  display: flex;
  align-items: center;
}
.lang-block .lang-item {
  cursor: pointer;
  opacity: 0.5;
}
.lang-block .lang-item h3 {
  margin: 0;
  font-size: 14px;
  color: white;
  font-family: AppFontMedium, sans-serif;
}
.lang-block .lang-item.selected {
  opacity: 1;
}
.lang-block .lang-item.selected h3 {
  color: var(--accent-color);
}
.lang-block .vertical-line {
  width: 1px;
  height: 14px;
  margin: 0 12px;
  background: rgba(255, 255, 255, 0.4);
}

.version {
  opacity: 0.3;
  font-size: x-small;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,YAAA;EACA,kCAAA;EACA,YAAA;AADD;;AAIA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;AADD;;AAIA;EACC,aAAA;AADD;;AAIA;EACC,yBAAA;AADD;AAGC;EACC,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAKA;EACC,oBAAA;EACA,iDAAA;AAFD;;AAKA;EACC,SAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;AAFD;;AAKA;EACC,eAAA;EACA,eAAA;EACA,gCAAA;EACA,gCAAA;AAFD;;AAKA;EACC,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,sCAAA;AAFD;;AAKA;EACC,eAAA;EACA,eAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,iDAAA;AAFD;AAIC;EACC,0BAAA;AAFF;;AAMA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;AAHD;;AAMA;EACC,aAAA;EACA,mBAAA;AAHD;AAKC;EACC,eAAA;EACA,YAAA;AAHF;AAKE;EACC,SAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;AAHH;AAME;EACC,UAAA;AAJH;AAMG;EACC,0BAAA;AAJJ;AASC;EACC,UAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;AAPF;;AAWA;EACC,YAAA;EACA,kBAAA;EACA,YAAA;AARD","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\theight: 100%;\n\tbackground: var(--main-background);\n\tcolor: white;\n}\n\n.wrapper {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\toverflow-y: auto;\n}\n\n.header-section {\n\tpadding: 20px;\n}\n\n.header-btn {\n\tjustify-content: flex-end;\n\n\tion-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tcursor: pointer;\n\t}\n}\n\n.header-wrap {\n\tpadding: 10px 0 20px;\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.name {\n\tmargin: 0;\n\tfont-size: 22px;\n\tcolor: white;\n\tfont-family: AppFontMedium, sans-serif;\n}\n\n.email {\n\tmargin: 4px 0 0;\n\tfont-size: 14px;\n\tfont-family: AppFont, sans-serif;\n\tcolor: var(--ion-color-subtitle);\n}\n\n.section-title {\n\tmargin: 24px 0 4px;\n\tfont-size: 12px;\n\tletter-spacing: 0.08em;\n\ttext-transform: uppercase;\n\tcolor: var(--accent-color);\n\tfont-family: AppFontMedium, sans-serif;\n}\n\n.menu-row {\n\tpadding: 14px 0;\n\tfont-size: 16px;\n\tfont-family: AppFontMedium, sans-serif;\n\tcolor: white;\n\tcursor: pointer;\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n\t&:hover {\n\t\tcolor: var(--accent-color);\n\t}\n}\n\n.footer-section {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 16px 20px;\n\tborder-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.lang-block {\n\tdisplay: flex;\n\talign-items: center;\n\n\t.lang-item {\n\t\tcursor: pointer;\n\t\topacity: 0.5;\n\n\t\th3 {\n\t\t\tmargin: 0;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t}\n\n\t\t&.selected {\n\t\t\topacity: 1;\n\n\t\t\th3 {\n\t\t\t\tcolor: var(--accent-color);\n\t\t\t}\n\t\t}\n\t}\n\n\t.vertical-line {\n\t\twidth: 1px;\n\t\theight: 14px;\n\t\tmargin: 0 12px;\n\t\tbackground: rgba(255, 255, 255, 0.4);\n\t}\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n\tcolor: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
